import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../types/store';
import { TabBarProps as Props } from './types';
import {
  getPage,
  getCurrentFeedType,
  getFeedTypeSubnavigation,
  getCurrentPageType,
} from '../../selectors/page';
import { Pages } from '../../../constants';

export type StateProps = Pick<
  Props,
  'items' | 'activeMenuItem' | 'pageType' | 'isSearchPage'
>;
export type OwnProps = Omit<Props, keyof StateProps | 'isStuck'>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  return {
    activeMenuItem: getCurrentFeedType(state),
    isSearchPage: getPage(state) === Pages.Search,
    items: getFeedTypeSubnavigation(state)?.options,
    pageType: getCurrentPageType(state),
  };
};

export default connect(mapStateToProps);
